import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { Modal, Card, Row, Col, Input, Button, Switch } from 'antd';
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import './AddPoint.scss';

const AddProduct: React.FC = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    description: '',
    platform: '',
    bot_file: '',
    settings: '',
    is_public: true,
    version: null
  } as any);

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!form.name.trim()) {
      Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng nhập tên' });
      return;
    }
    if (!form.platform.trim()) {
      Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng nhập platform' });
      return;
    }
    if (!form.bot_file) {
      Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng nhập File Bot' });
      return;
    }

    function removeEmpty(obj: any) {
      return Object.fromEntries(
        Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null && v !== "")
      );
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("platform", form.platform);
      formData.append("bot_file", form.bot_file);
      formData.append("is_public", form.is_public);

      if (form.description.trim()) formData.append("description", form.description);
      if (form.settings) formData.append("settings", form.settings);
      if (form.version.trim()) formData.append("version", form.version);

      const response = await fetch(`${API_URL}api/v1/be/bots`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const json = await response.json();

      if (json.status) {
        Modal.success({
          title: 'Success',
          content: 'Operation completed successfully',
          onOk: () => navigate('/bots'),
        });
      } else {
        Modal.error({
          title: 'Error',
          content: json.error[Object.keys(json.error)[0]] || 'Unknown error',
        });
      }
    } catch (error: any) {
      Modal.error({
        title: 'Error',
        content: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4"></h4>}>
      <div className='head-form-box mb-4'>
        <div className='box-left'>
          <ArrowLeftOutlined
            onClick={() => navigate('/bots')}
          />
          <div className='title'>Add Bots</div>
        </div>
        <Button loading={loading} onClick={handleSave} type="primary" icon={<SaveOutlined />} size="large">
          Add new
        </Button>
      </div>
      <Row gutter={[16, 16]} className='AddProduct'>
        <Col span={24} lg={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Name
                  </label>
                  <Input
                    type="text"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Description
                  </label>
                  <Input
                    type="text"
                    value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Platform
                  </label>
                  <Input
                    type="text"
                    value={form.platform}
                    onChange={(e) => setForm({ ...form, platform: e.target.value })}
                  />
                </div>
              </Col>
              <Col span={12}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Version
                  </label>
                  <Input
                    type="number"
                    value={form.version}
                    onChange={(e) => setForm({ ...form, version: e.target.value })}
                  />
                </div>
              </Col>
              <Col span={24}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Settings
                  </label>
                  <Input
                    type="text"
                    value={form.settings}
                    onChange={(e) => setForm({ ...form, settings: e.target.value })}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: "#5e5873" }}>
                    File Bot
                  </label>
                  <Input
                    type="file"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setForm({ ...form, bot_file: file });
                      }
                    }}
                  />
                </div>
              </Col>

            </Row>
          </Card>
        </Col>
        <Col span={24} lg={6}>
          <Card>
            {/* <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                Locale
              </label>
              <Select
                onChange={(e) => setForm({ ...form, locale: e })}
                value={form.locale}
                style={{ width: '100%' }}
              >
                <option value="vi">Vietnam</option>
                <option value="en">English</option>
              </Select>
            </div> */}
            <div>
              <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                Public
              </label>
              <Switch checked={form.is_public} onChange={(value) => setForm({ ...form, is_public: value })} />
            </div>
          </Card>
        </Col>
      </Row>
      <div className='ctrbox-foot mt-4'>
        <Button loading={loading} onClick={handleSave} type="primary" icon={<SaveOutlined />} size="large">
          Add new
        </Button>
      </div>
    </SidebarLayout>
  );
};

export default AddProduct;